/**
 * Mixin obsługi klawiatury
 *
 * Zawiera metody:
 *  - `keydownHandler(functionName, argument)` - Wywołuje metodę po wciśnięciu entera lub spacji
 */
export const keyboardMixin = {
  methods: {
    /**
     * Wywołanie metody po wciśnięciu entera lub spacji
     *
     * @param {*} functionName
     * @param {*} argument
     */
    keydownHandler(functionName, argument) {
      if (event.code === 'Enter' || event.code === 'Space') {
        this[functionName](argument);
      }
    }
  }
};
